

























































































































































































































































































































// vue
import {
    computed,
    defineComponent,
    onBeforeMount,
    ref,
} from '@vue/composition-api';

// store
import store from '@/store';

// hooks
import { useGeoRecordDelete } from '@/vue3/hooks/geoRecordDeleteHook';
import { useNotify } from '../hooks/notifyHook';
import { useGeoRecord } from '../hooks/geoRecordHook';
import { Role } from '../api/models';

// components
import { Portal } from '@linusborg/vue-simple-portal';
import {
    Category,
    FileUpload,
    Measurement,
    Notes,
    Project,
    Task,
    Title,
    Model,
    Height,
    Label,
    Fill,
    MeasureLabel,
    Tags,
    Events,
    Opacity,
} from '@/vue3/components/geo-record-editor';
import Surface from '@/vue3/components/Surface.vue';
import ModifyGeometry from '@/vue3/components/geo-record-editor/ModifyGeometry.vue';

// primevue
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Confirm from '@/vue3/components/Confirm.vue';
import Dialog from 'primevue/dialog';
import ProgressSpinner from 'primevue/progressspinner';
import InputSwitch from 'primevue/inputswitch';

// services
import { useService } from '@/vue3/api/services';

// store
import { useStore } from '@/store';

export default defineComponent({
    components: {
        Category,
        FileUpload,
        Measurement,
        Notes,
        Project,
        Task,
        Title,
        Model,
        Height,
        Label,
        Fill,
        MeasureLabel,
        Tags,
        Events,
        Accordion,
        AccordionTab,
        Surface,
        Button,
        ModifyGeometry,
        Confirm,
        Dialog,
        Portal,
        ProgressSpinner,
        InputSwitch,
        Opacity,
    },
    props: {
        mapbox: {
            type: Object,
            default: () => {},
        },
        value: {
            type: Object,
            default: () => {},
        },
        saveGeoRecord: {
            type: Function,
            default: () => {},
        },
        cancelModify: {
            type: Function,
            default: () => {},
        },
        isCreating: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        categorySummaries: {
            type: Array,
            default: () => [],
        },
        clearGeoRecord: {
            type: Function,
            default: () => {},
        },
        updateGeoRecordExternal: {
            type: Function,
            default: () => {},
        },
        updateAndRefreshGeoRecord: {
            type: Function,
            default: () => {},
        },
        toggleModifyToolVisibility: {
            type: Function,
            default: () => {},
        },
        isModifyAllowed: {
            type: Boolean,
            default: true,
        },
        updateData: {
            type: Function,
            default: () => {},
        },
        isEditorVisible: {
            type: Boolean,
            default: false,
        },
        setIsEditorVisible: {
            type: Function,
            default: () => {},
        },
        refreshTable: {
            type: Function,
            default: () => {},
        },
        rowId: {
            type: Number,
            default: 0,
        },
        toggleIsArchive: {
            type: Function,
            default: () => {},
        },
        layerTree: {
            type: Object,
            default: null,
        },
    },
    setup(props: any) {
        // hooks
        const { deleteGeoRecordLayer } = useGeoRecordDelete();
        const {
            removeSelectedGeoRecord,
            removeGeoRecordExtrusion,
            removeGeoRecord,
        } = useGeoRecord();

        // store
        const { getters } = useStore();
        const { successToast, errorToast } = useNotify();

        // services
        const {
            updateGeoRecord,
            getRole,
            getGeoRecord,
            createArchiveGeoRecord,
        } = useService();

        // refs
        const isDeleteVisible = ref<boolean>(false);
        const isDeleteLoading = ref<boolean>(false);
        const permissionsInitArr: Array<string> = [];
        const role = ref<Role>({
            permissions: [...permissionsInitArr],
        } as Role);

        const geoRecord = ref(props.value);

        // computed
        const isNonGeometry = computed(() => {
            if (!props.value.geometry) {
                return false;
            }
            if (props.value.geometry.coordinates[0] === 0) {
                return true;
            }
            return false;
        });

        // methods
        const confirmDeleteGeoRecord = async () => {
            isDeleteLoading.value = true;
            try {
                await deleteGeoRecordLayer(props.mapbox.map, props.value);
                props.clearGeoRecord();
                removeGeoRecordExtrusion(props.mapbox.map, props.value);

                let georecordArry = [props.value.id];

                await props.layerTree.refreshGeoRecordTreeAndState(
                    georecordArry,
                    false,
                );
            } catch (error) {
                window.console.log(error);
                isDeleteLoading.value = false;
            }
            toggleIsDeleteVisible();
            isDeleteLoading.value = false;
        };

        const confirmDecline = () => {
            toggleIsDeleteVisible();
        };

        const toggleIsDeleteVisible = () => {
            isDeleteVisible.value = !isDeleteVisible.value;
        };

        const isGeomPolygon = computed(() => {
            if (
                !props.isLoading &&
                props.value.geometry &&
                (props.value.geometry.type === 'Polygon' ||
                    props.value.geometry.type === 'MultiPolygon')
            ) {
                return true;
            } else {
                return false;
            }
        });

        const moveGeoRecordToArchive = async (geoRecord: any) => {
            await createArchiveGeoRecord(geoRecord);

            successToast(
                `Geo Record: '${geoRecord.title}' successfully archived.`,
            );

            removeSelectedGeoRecord(props.mapbox.map, geoRecord);
            removeGeoRecordExtrusion(props.mapbox.map, geoRecord);
            removeGeoRecord(props.mapbox.map, geoRecord);
        };

        const updateGeoRecordData = async (): Promise<void> => {
            if (props.value.archiveEventId) {
                await moveGeoRecordToArchive(geoRecord.value);
            } else {
                if (geoRecord.value.imageSrc) {
                    geoRecord.value.imageSrc.forEach((img) => {
                        img.modifyDate = new Date(img.modifyDate).toISOString();
                    });
                }

                try {
                    const res = await updateGeoRecord(geoRecord.value, false);
                    if (res.status == 200 || res.status == 201) {
                        successToast('Successful!');
                    }
                } catch (e) {
                    errorToast('Error saving geo record!');
                }
            }
            props.refreshTable();
            props.setIsEditorVisible();
        };

        const setRoleValue = async (): Promise<void> => {
            role.value = await getRole(getters.account.roleId);
        };

        const setIsPrivate = (): void => {
            geoRecord.value.isPrivate = !geoRecord.value.isPrivate;
        };

        const handleGeoRecordPropertyUpdate = (
            geoRecordProperties: any = {},
        ) => {
            geoRecord.value = { ...geoRecord.value, ...geoRecordProperties };
            props.updateGeoRecordExternal(geoRecord.value);
            return geoRecord.value;
        };

        // lycycle
        onBeforeMount(async () => {
            try {
                await setRoleValue();

                if (props.isEditorVisible) {
                    geoRecord.value = await getGeoRecord(props.rowId);
                }
            } catch (error) {
                console.error('Error fetching role:', error);
            }
        });

        return {
            role,
            isDeleteVisible,
            isDeleteLoading,
            toggleIsDeleteVisible,
            confirmDeleteGeoRecord,
            confirmDecline,
            isGeomPolygon,
            isNonGeometry,
            updateGeoRecordData,
            geoRecord,
            handleGeoRecordPropertyUpdate,
            setIsPrivate,
            store,
        };
    },
});
